//---------	Global imports
import React from 'react';
//---------	Plugins
import { filter, includes, join } from 'lodash';
import { toast } from 'react-toastify';
import { onTemplateLoad } from '../Components/Shared/Commons'
//---------	Components
import ProductsList from '../components/ProductsList';
import ProductsFilters from '../components/ProductsFilters';
import Sidebar from '../components/Sidebar';
import Newsletter from '../components/Newsletter';
//---------	Translations
import { T } from '../../translations';
//---------  Products List
import productsList from '../pages/shop/productsList.json';
import SEO from '../components/SEO/index';


class ShopTemplate extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super(props);
    
    this.activeCategoriesMessage = T.shop.browsing.all;
    this.categories = this.createCategoriesList(productsList);
    this.state = {
      filters: [],
      loading: true
    };
    
    this.createFiltersMessage = this.createFiltersMessage.bind(this);
  }
  
  //---------	React functions
  componentDidMount() {
    setTimeout(() => this.setState({loading: false}), 300);
    setTimeout(() => onTemplateLoad());
  }
  
  
  //---------	Custom functions
  toggleSidebar(sendToast) {
    this.child.toggleSidebar();
    
    if (sendToast === 'sendToast') {
      toast.info(<div className="filtersApplied info">{T.global.filtersApplied}</div>, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500
      });
    }
  }
  
  callback(response) {
    this.createFiltersMessage(response);
    this.setState({filters: response});
  }
  
  createCategoriesList(products) {
    const categories = [];
    
    filter(products, (product) => {
      if (!includes(categories, product.category)) {
        categories.push(product.category);
      }
    });
    
    return categories;
  }
  
  createFiltersMessage(filters) {
    const activeCategories = filter(this.categories, (filter) => !includes(filters, filter));
    
    if (activeCategories.length === this.categories.length) {
      this.activeCategoriesMessage = T.shop.browsing.all;
    }
    else {
      this.activeCategoriesMessage = T.shop.browsing.list + join(activeCategories, ', ');
    }
  }
  
  
  //---------	Render
  render() {
  
    const data = this.props.data.markdownRemark.frontmatter;
    const seo = {
      title: `${T.SEO.title.shop} - ${data.title} | Calipsy`
    };
    
    return (
      <div className={this.state.loading ? 'CalipsyWrapper CalipsyWrapper-loading' : 'CalipsyWrapper'}>
  
        <SEO {...seo}/>
        
        <div className="CalipsySpinner"></div>
        <div className="CalipsyWrapper-container">
          <div className="CalipsyShop">
            <div className="CalipsyContainer">
              <h4>
                <span>{this.activeCategoriesMessage}</span>
                <button className="CalipsyButton"
                        onClick={this.toggleSidebar.bind(this)}>{T.shop.messages.changeFilters}</button>
              </h4>
              
              <ProductsList productsList={productsList} filters={this.state.filters}/>
            
            </div>
            
            <Newsletter/>
          
          </div>
        </div>
        
        <Sidebar onRef={ref => (this.child = ref)} title={T.shop.messages.filtersTitle}>
          <ProductsFilters toggleSidebar={this.toggleSidebar.bind(this)} onRef={ref => (this.child = ref)}
                           categories={this.categories} filters={response => this.callback(response)}/>
        </Sidebar>
      </div>
    );
  }
}

export default ShopTemplate;

export const pageQuery = graphql`
  query ShopQuery($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      frontmatter {
        title
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/shop.js